import React from "react";
import styled from "styled-components";
import { Skeleton, Card } from "fiver-react-ui-components";
import WalletTicketsRow from "./WalletTicketsRow";
import TicketDashedLine from "./TicketDashedLine";
import TicketMain from "./TicketMain";
import TicketMainBottomRow from "./TicketMainBottomRow";
import TicketMainMiddleRow from "./TicketMainMiddleRow";
import TicketMainTopRow from "./TicketMainTopRow";
import TicketStub from "./TicketStub";
import TicketText from "./TicketText";
const StyledWrapper = styled.div``;
const rows = new Array(4);

const Wrapper = () => {
  return /*#__PURE__*/React.createElement(WalletTicketsRow, null, /*#__PURE__*/React.createElement(Card, {
    minHeight: "232px",
    margin: "0 0 1rem",
    padding: "0"
  }, /*#__PURE__*/React.createElement(TicketMain, {
    isSkeleton: true
  }, /*#__PURE__*/React.createElement(TicketMainTopRow, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
    display: "block",
    skeletonHeight: "18px",
    skeletonWidth: "240px",
    margin: "10px 0 32px"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    display: "block",
    skeletonHeight: "16px",
    skeletonWidth: "180px",
    margin: "10px 0 32px"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    display: "block",
    skeletonHeight: "16px",
    skeletonWidth: "100px"
  }))))));
};

export default Wrapper;